
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { ServiceWorkerManager } from "./ServiceWorkerManager";

import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import EntryView from "./pages/EntryView";
import EntryEditor from "./pages/EntryEditor";
import SharedEntry from "./pages/SharedEntry";
import ShareTarget from "./pages/ShareTarget";
import ProtocolHandler from "./pages/ProtocolHandler";
import NotFound from "./pages/NotFound";
import DashboardLayout from "./layouts/DashboardLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import SharedNotes from "./pages/SharedNotes";
import Postscript from "./pages/Postscript";

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider defaultTheme="system" storageKey="theme">
          <ServiceWorkerManager />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="entry/:id" element={<EntryView />} />
              <Route path="edit/:id" element={<EntryEditor />} />
              <Route path="entry/new" element={<EntryEditor />} />
            </Route>
            <Route path="/shared-notes" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<SharedNotes />} />
            </Route>
            <Route path="/postscript" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Postscript />} />
            </Route>
            <Route path="/shared/:shareId" element={<SharedEntry />} />
            <Route path="/share-target" element={<ShareTarget />} />
            <Route path="/protocol-handler" element={<ProtocolHandler />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster richColors />
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
